import './Footer.css';
export default function Footer(){
    return<>
        <div className='footer'>
            <p>2030 All Rights Reserved © UnityKick</p>
        </div>
    </>
}